import React, { lazy, Suspense } from "react";
// Capture only our public, server-rendered article before createRoot replaces #root.
// Keeping the same content as the pending route avoids a short loading-screen layout shift.
const initialArticle =
  typeof document === "undefined"
    ? ""
    : document.querySelector("#root article.selling-guide")?.outerHTML || "";
const Page = lazy(() => import("../../pages/seo/SaljaMedKlassenPage.jsx"));
export default function SellingGuideRoute() {
  return (
    <Suspense
      fallback={
        initialArticle ? (
          <div dangerouslySetInnerHTML={{ __html: initialArticle }} />
        ) : (
          <div className="p-6">Laddar…</div>
        )
      }
    >
      <Page />
    </Suspense>
  );
}
